export const enableDesign = (designClassName: string) => {
  document.documentElement.classList.add(designClassName);
};
